import React, { useCallback } from 'react';
import { EditorTheme } from '@loyalty/shared-common/template-api-client';
import { EditorComponentSidebar } from './component-sidebar/EditorComponentSidebar';
import { EditorGeneralSidebar } from './general-sidebar/EditorGeneralSidebar';
import { useEditorStore } from '../../store';

export function EditorSidebar(): React.ReactElement {
  const selectedComponent = useEditorStore(state => state.selectedComponent);
  const editorTheme = useEditorStore(state => state.editorTheme);
  const setEditorTheme = useEditorStore(state => state.setEditorTheme);
  const markAsDirty = useEditorStore(state => state.markAsDirty);

  const handleThemeChanged = useCallback(
    (theme: EditorTheme) => {
      setEditorTheme(theme);
      markAsDirty();
    },
    [setEditorTheme, markAsDirty],
  );

  return (
    <>
      <EditorGeneralSidebar
        theme={editorTheme}
        onThemeChanged={handleThemeChanged}
        sx={selectedComponent ? { display: 'none' } : undefined}
      />
      <EditorComponentSidebar sx={!selectedComponent ? { display: 'none' } : undefined} />
    </>
  );
}
